/**
 * 百度、谷歌统计
 */

if (['production', 'dev'].includes(import.meta.env.MODE)) {
  setupBDStatistics()
}

/**
 * 百度统计
 * 后台已开启单页面统计
 */
export function setupBDStatistics() {
  const statSrc = import.meta.env.VITE_BAIDU_STAT_URL
  if (!statSrc) return
  window._hmt = []
  let hm = document.createElement('script')
  hm.async = 'async'
  hm.src = statSrc
  document.body.appendChild(hm)
}
